<template>
  <div class="relative">
    <vue-web-cam
      ref="webcam"
      :device-id="deviceId"
      width="100%"
      @started="onStarted"
      @stopped="onStopped"
      @error="onError"
      @notsupported="onError"
      @cameras="onCameras"
      @camera-change="onCameraChange"
      screenshotFormat="image/png"
      v-if="showCam"
    />
    <loading
      :active.sync="videoLoading"
      :can-cancel="false"
      :is-full-page="true"
      :color="this.$primaryColor"
    ></loading>
    <div
      class="
        w-full
        text-center
        flex
        justify-between
        absolute
        bottom-2
        space-x-2
      "
      v-show="!videoLoading"
    >
      <div class="flex-1"></div>
      <button
        type="button"
        class="rounded-full100 p-4 bg-gray-600 bg-opacity-50"
        @click="onCapture"
      >
        <CameraIcon class="text-white" />
      </button>

      <div class="flex-1 flex justify-start items-center">
        <div class="relative w-full" v-if="devices && devices.length > 1">
          <button
            type="button"
            class="rounded-full100 p-2 bg-gray-600 bg-opacity-50"
            @click="onCapture"
          >
            <RefreshIcon class="text-white" @click="switchCamera" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WebCam } from "vue-web-cam";
import { CameraIcon, RefreshIcon } from "@vue-hero-icons/outline";

export default {
  components: {
    "vue-web-cam": WebCam,
    CameraIcon: CameraIcon,
    RefreshIcon: RefreshIcon
  },
  props: {
    showCam: {
      default: false,
    },
  },
  data() {
    return {
      camera: null,
      deviceId: null,
      devices: [],
      videoLoading: true,
      deviceIndex: 0,
      img: null,
    };
  },
  computed: {
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
    showCam: function () {
      if (this.showCam && this.devices.length > 0) {
        this.$nextTick(() => {
          this.onStart();
        });
      }
    },
  },
  methods: {
    switchCamera() {
      this.deviceIndex++;
      if (this.deviceIndex >= this.devices.length) {
        this.deviceIndex = 0;
      }
      this.onCameraChange(this.devices[this.deviceIndex].deviceId);
    },
    onCapture() {
      this.img = this.$refs.webcam.capture();
      this.$emit("img", this.$refs.webcam.capture());
    },
    onStarted(stream) {
      this.videoLoading = false;
    },
    onStopped(stream) {
      this.videoLoading = true;
    },
    onStop() {
      this.videoLoading = true;
      this.$refs.webcam.stop();
    },
    onStart() {
      this.videoLoading = true;
      this.$refs.webcam.start();
    },
    onError(error) {
      this.$store.commit("showFlashMessage", {
        message: error,
        type: "danger",
      });
    },
    onCameras(cameras) {
      this.devices = cameras;
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
    },
  },
};
</script>

<style>
.deviceSelect .multiselect__tags,
.deviceSelect .multiselect__select {
  display: none;
}
</style>